import React, { useState, useEffect } from "react";
import { cardMediaClasses } from "@mui/material";
import WhatMakesUsDifferentCategorySelector from "../MakesUsDifferentCategorySelector";
import "./WhatMakesUsDifferent.css";
import forCoords from "./forCoords";
import forParticipants from "./forParticipants";
import forSupporters from "./forSupporters";

export interface WhatMakesUsDifferentSingleComponentProps {
  icon: React.ReactNode;
  header: string;
  subText: string;
}

const WhatMakesUsDifferentSingleComponent: React.FC<
  WhatMakesUsDifferentSingleComponentProps
> = ({ icon, header, subText }) => {
  return (
    <div className="homepage-wmud-card">
      <div className="homepage-wmud-icon">{icon}</div>
      <h3 className="homepage-wmud-header">{header}</h3>
      <p className="homepage-wmud-subtext">{subText}</p>
    </div>
  );
};

const categorySelections = [
  "For Coordinators",
  "For Supporters",
  "For Participants",
] as const;
export type MakesUsDifferentCategories = (typeof categorySelections)[number];

const WhatMakesUsDifferent = () => {
  const [selectedCategory, setSelectedCategory] =
    useState<MakesUsDifferentCategories>(categorySelections[0]);
  const mapCategorySelectionToDisplay = {
    "For Coordinators": forCoords,
    "For Supporters": forSupporters,
    "For Participants": forParticipants,
  };

  useEffect(() => {
    setDisplayComponents(mapCategorySelectionToDisplay[selectedCategory]);
  }, [selectedCategory]);

  const [displayComponents, setDisplayComponents] = useState(forCoords);
  return (
    <div className="homepage-wmud-container">
      <h2>
        What Makes Us{" "}
        <span className="homepage-wmud-font-change">Different</span>
      </h2>
      <WhatMakesUsDifferentCategorySelector
        categories={categorySelections}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />

      <div className="container mt-4">
        <div className="row g-4">
          {displayComponents.map((component, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4">
              <WhatMakesUsDifferentSingleComponent
                icon={component.icon}
                header={component.header}
                subText={component.subText}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatMakesUsDifferent;
